export enum DownloadTypes {
  Track = 'track',
  Playlist = 'playlist',
  Likes = 'likes'
}
